import e from "../managers/braze-instance.js";
import HtmlMessage from "./models/html-message.js";
import se from "./in-app-message-manager-factory.js";
import r from "../../shared-lib/braze-shared-lib.js";
import tt from "../triggers/models/trigger-events.js";
import { TriggersProviderFactory as et } from "../triggers/triggers-provider-factory.js";
export function logInAppMessageHtmlClick(s, t, o) {
  if (!e.rr()) return !1;
  if (!(s instanceof HtmlMessage))
    return (
      r.j.error(
        "inAppMessage argument to logInAppMessageHtmlClick must be an HtmlMessage object.",
      ),
      !1
    );
  let m = r.q.Li;
  null != t && (m = r.q.Qi);
  const i = se.m().N(s, m, t, o);
  if (i.O)
    for (let r = 0; r < i.ve.length; r++)
      et.er().be(tt.ro, [s.triggerId, t], i.ve[r]);
  return i.O;
}
